import { ValidatorFn, Validators } from '@angular/forms';
import { LogicalOperators } from '@uigy/shared/form-validators/logical-operator.validator';
import { RegexEnum, RegularExpressions } from '@uigy/shared/enums/regex.enum';

export const hostnameValidator: ValidatorFn = LogicalOperators.OR([
  Validators.pattern(RegularExpressions[RegexEnum.ip]),
  Validators.pattern(RegularExpressions[RegexEnum.hostname])
]);
